/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Logo_LengthInputs */

const fr_validation_logo_length = /** @type {(inputs: Validation_Logo_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitez l’adresse du logo à 2 048 caractères.`)
};

const en_validation_logo_length = /** @type {(inputs: Validation_Logo_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the logo address within 2,048 characters.`)
};

/**
* | output |
* | --- |
* | "Keep the logo address within 2,048 characters." |
*
* @param {Validation_Logo_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_logo_length = /** @type {((inputs?: Validation_Logo_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Logo_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_logo_length(inputs)
	return fr_validation_logo_length(inputs)
});